import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getErrorMessageKey, getErrorStatus } from '../utils/errors';

export const useErrorMessage = () => {
  const { t } = useTranslation();

  const getErrorMessage = useCallback(
    (error?: unknown): string => t(getErrorMessageKey(error)),
    [t]
  );

  return { getErrorMessage, getErrorStatus };
};
